import { useEventListener, useRafState } from 'ahooks';

export type WindowSize = {
  width: number;
  height: number;
};

const isBrowser = typeof window !== 'undefined';

export function useWindowSize(initialWidth = Infinity, initialHeight = Infinity): WindowSize {
  const [size, setSize] = useRafState<WindowSize>({
    width: isBrowser ? window.innerWidth : initialWidth,
    height: isBrowser ? window.innerHeight : initialHeight,
  });

  useEventListener('resize', () => {
    setSize({ width: window.innerWidth, height: window.innerHeight });
  });

  return size;
}
